<div class="container food-item-data">
    <div class="row tot-pad">
        <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12">
            <div style="margin-bottom: 15px;display: flex;justify-content: space-between;">
                <div style="margin-bottom: 25px" class="addeve-sty">
                    Items
                </div>
                <div>
                    <!-- <img style="cursor: pointer;" src="../../../../assets/icons/Info Circle.png" alt=""
              (click)="modalRef.hide()" /> -->
                </div>
            </div>
        </div>


        <div class="row productlist">
            <div class="col-md-6" *ngFor="let val of productsList">
                <div style="background: rgba(245, 246, 252, 1); border-radius: 10px; padding: 15px; margin-top: 10px;">
                    <div>
                        <img class="food-img" style="border-radius: 10px;" [src]="val.productImage" />
                    </div>

                    <div style="margin-top: 10px; display: flex; justify-content: space-between;">
                        <div class="fries-text">{{val.productName}}</div>
                    </div>

                    <div style="margin-top: 10px;" class="num-align">
                        <div style="margin-top: 10px;">
                            <div class="amount-2">$ {{val.productPrice}}</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <div style="padding-top: 20px;">
            <button class="menu-back-btn" (click)="onclickmenuback()">Go Back</button>
        </div>
    </div>
</div>